import { combineReducers } from "redux";
import playPauseSound from "./reducers/playPauseSoundReducer";
import changeLanguage from "./reducers/changeLanguageReducer";
import randomArtwork from "./reducers/randomArtworkReducer";

export default combineReducers({
  playPauseSound,
  changeLanguage,
  randomArtwork,
});
